import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Input from "../../components/Input";
import MetricsCard from "../../components/MetricsCard";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import StatusAlert from "../../components/StatusAlert";
import { Reducers } from "../../Interfaces/Interfaces";
import { getTradePartnerLocation } from "../../redux/actions/AggregatorAction";
import {
  getCoordinatorPerformanceTarget,
  getCoordinatorTransactionDashboard,
} from "../../redux/actions/CoordinatorActions";
import { getTransactionDashboard } from "../../redux/actions/DashboardActions";
import {
  assignMultipleTerminal,
  assignTerminal,
  getAggregatorAgents,
  getCoordinatorTerminals,
  getTerminals,
  retrieveTerminal,
  toggleTerminalState,
} from "../../redux/actions/POSAction";
import { getPOSDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
// import PosMapTerminal from './PosMapTerminal'
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getCurrency } from "../../helpers/Functions";
import { getFloatRequestFilterDashboard } from "../../redux/actions/FloatFinanceAction";
import Meter from "../../components/Meter";
import { getPerformanceTarget } from "../../redux/actions/TransactionActions";
import {
  getAgentsPerformance,
  getAggregatorPerformanceAction,
  getStateCordinatorPerformance,
  salesCordinatorPerformanceAction,
} from "../../redux/actions/AgentActions";
export default function PerformanceChart() {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state: Reducers) => state.user);
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const agents = useSelector((state: Reducers) => state.agents);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const terminals = useSelector((state: Reducers) => state.terminals);
  const userType = useSelector((state: Reducers) => state.userType);
  const loader = useSelector((state: Reducers) => state.internalLoader);
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);
  const target = useSelector((state: Reducers) => state.target);
  const agentPerformanceList = useSelector(
    (state: any) => state.agentPerformanceList
  );

  const getAggregatorPerformance = useSelector(
    (state: any) => state.getAggregatorPerformance
  );

  const [searchState, setSearchState] = React.useState("");
  const [SearchTradePartner, setSearchTradePartner] = React.useState("");

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [pin, setPin] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [terminal, setTerminal]: any = React.useState("");
  const [comment, setComment]: any = React.useState("");
  const [title, setTitle]: any = React.useState("");
  const [item, setItem]: any = React.useState("");
  const [subtitle, setSubtitle]: any = React.useState("");
  const [agent, setAgent]: any = React.useState("");
  const [agentId, setAgentId]: any = React.useState("");
  const [type, setType] = React.useState(0); // retrieve = 1, start = 2, stop = 4, assign = 3, multiple=5
  const [submitted, setSubmitted] = React.useState(false);
  const [posState, setPosState]: any = React.useState(0);
  const [targetStatus, setTargetStatus]: any = React.useState(0);
  const [groupTerminal, setgroupTerminal] = useState(false);
  const [multipleTerminal, setmultipleTerminal]: any = useState([]);
  const [transPeriod, setTransPeriod] = React.useState(1);
  const [transLoading, setTransLoading] = React.useState(false);
  const [requestLoading, setrequestLoading] = React.useState(false);
  const [requestPeriod, setrequestPeriod] = React.useState(1);
  const [period, setperiod] = React.useState(1);
  const [approvePeriod, setapprovePeriod] = React.useState(1);
  const [approveLoading, setapproveLoading] = React.useState(false);
  const [defaultPeriod, setdefaultPeriod] = React.useState(1);
  const [defaultLoading, setdefaultLoading] = React.useState(false);
  const [targetLoading, setTargetLoading] = React.useState(false);
  const requestDashboardReducer = useSelector(
    (state: any) => state.requestDashboardReducer
  );
  const [targetPeriod, setTargetPeriod] = React.useState(1);
  const [TransferTargetState, setTransferTargetState]: any = React.useState(0);
  const [POSWithdrawState, setPOSWithdrawState]: any = React.useState(0);
  let targetFilter = { period: targetPeriod };
  const [rangeState, setrangeState] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  let list = agentPerformanceList && agentPerformanceList.data;

  let getAggregatorList =
    getAggregatorPerformance && getAggregatorPerformance.data;

  let filter: any = {};
  let filterTransaction = { period: transPeriod };
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  let checkItems: any[] = [];
  let filter1 = { period };
  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    if (userType === "5") {
    }
  };

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);
    setSearchState("");
    setPosState(0);
    setTargetStatus(0);
    setSearchTradePartner("");
  };

  const callPerformanceAgent = () => {
    if (userType !== "8") {
      dispatch(getAggregatorPerformanceAction(paginationConfig));
      dispatch(getAgentsPerformance(paginationConfig));
      dispatch(getAggregatorAgents(user.id));
    } else {
      dispatch(getStateCordinatorPerformance(paginationConfig));
      dispatch(salesCordinatorPerformanceAction(paginationConfig));
    }
  };

  const closeModal = () => {
    setType(0);
    setLoading(false);
    setType(0);
    setAgent("");
    setTerminal("");
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    setPageSize(value.props.value);
    paginationConfig.pageSize = value.props.value;
    callPerformanceAgent();
  };

  React.useEffect(() => {
    if (searchState.length !== 0) {
      filter.agentId = searchState;

      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      if (userType !== "8") {
        dispatch(getAgentsPerformance(paginationConfig));
      } else {
        dispatch(getStateCordinatorPerformance(paginationConfig));
      }
    } else {
      if (userType !== "8") {
        dispatch(getAgentsPerformance(paginationConfig));
      } else {
        dispatch(getStateCordinatorPerformance(paginationConfig));
      }
    }

    if (targetStatus !== 0) {
      filter.targetStatus = targetStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      callPerformanceAgent();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posState, dispatch, targetStatus, searchState]);

  React.useEffect(() => {
    if (SearchTradePartner.length !== 0) {
      filter.aggregatorId = SearchTradePartner;

      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });

      // callPerformanceAgent();
      if (userType !== "8") {
        dispatch(getAggregatorPerformanceAction(paginationConfig));
      } else {
        dispatch(salesCordinatorPerformanceAction(paginationConfig));
      }
    } else {
      if (userType !== "8") {
        dispatch(getAggregatorPerformanceAction(paginationConfig));
      } else {
        dispatch(salesCordinatorPerformanceAction(paginationConfig));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SearchTradePartner, dispatch]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callPerformanceAgent();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    if (userType === "5") {
      // dispatch(getPOSDashboard(user.id));
    }

    return () => {
      // dispatch({
      //   type: 'DASHBOARD',
      //   payload: {}
      // });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
        setLoading(false);
      } else {
        if (alert.message === "Successful") {
          callPerformanceAgent();
          closeModal();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  const [tofalse, settofalse]: any = useState({
    id: "",
  });

  React.useEffect(() => {
    if (multipleTerminal.length === 0) {
      setgroupTerminal(false);
    }
  }, [multipleTerminal]);

  const handleSelectTerminal = (check: any, terminalValue: any) => {
    let data = {
      id: terminalValue.id,
      checked: true,
      terminalId: terminalValue.terminalId,
    };

    if (check) {
      // checkItems.push(data);

      setmultipleTerminal([...multipleTerminal, data]);
    } else {
      const getStateFilter = multipleTerminal.filter(
        (item: any) => item.terminalId !== data.terminalId
      );
      setmultipleTerminal([...getStateFilter]);
    }
  };

  const handleChangeF = (value: any, type: string) => {
    switch (type) {
      case "request": {
        setrequestLoading(true);
        setrequestPeriod(value);
        setperiod(value);
        break;
      }
      case "approve": {
        setapproveLoading(true);
        setapprovePeriod(value);
        setperiod(value);
        break;
      }
      case "default": {
        setdefaultLoading(true);
        setdefaultPeriod(value);
        setperiod(value);
        break;
      }

      default:
        return;
    }
  };
  React.useEffect(() => {
    if (!loader) {
      setrequestLoading(false);
      setapproveLoading(false);
      setdefaultLoading(false);
      setTargetLoading(false);
    }
  }, [loader]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    // setrequestLoading(false);

    if (userType !== "8") {
      dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, defaultPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    if (userType !== "8") {
      dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));
    }
  }, [dispatch, requestPeriod]);

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    if (userType !== "8") {
      dispatch(getFloatRequestFilterDashboard(JSON.stringify(filter1)));
    }
  }, [dispatch, approvePeriod]);

  const handleTarget = (value: any) => {
    setTargetLoading(true);
    setTargetPeriod(value);
  };

  React.useEffect(() => {
    dispatch({
      type: "INTERNAL_LOADER",
      payload: true,
    });

    if (userType === "5") {
      dispatch(getPerformanceTarget());
    } else {
      dispatch(getCoordinatorPerformanceTarget(JSON.stringify(filter)));
    }
  }, [dispatch, targetPeriod]);

  React.useEffect(() => {
    switch (String(targetPeriod)) {
      case "1":
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );

        break;
      case "2":
        setTransferTargetState(target.weeklyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.weeklyPosCashWithdrawalTransactionTargetCount
        );

        break;
      case "3":
        setTransferTargetState(target.monthlyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.monthlyPosCashWithdrawalTransactionTargetCount
        );

        break;

      default:
        setTransferTargetState(target.dailyTranferTransactionTargetCount);
        setPOSWithdrawState(
          target.dailyPosCashWithdrawalTransactionTargetCount
        );

        break;
    }
  }, [dispatch, targetPeriod]);

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            height: "100vh",
            position: "relative",

            // zIndex: 1000,
          }}
        >
          <div className="row m-0 mb-4">
            <div
              className="col-md-12 content-area p-0 matrics-cover"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <div className="row ">
                <div className="col-md-9 col-6 ">
                  <h4
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                    }}
                  >
                    {user.businessName ? user.businessName : "N/A"}
                  </h4>
                  {/* <h6 style={{
        fontFamily: PrimaryTheme.fonts?.LightFont
      }}>{dashboard.wallet ? dashboard.wallet.bankName : "N/A"}</h6> */}
                  <h6
                    style={{
                      fontFamily: PrimaryTheme.fonts?.LightFont,
                    }}
                  >
                    {user.firstName && user.firstName}{" "}
                    {user.lastName && user.lastName} |{" "}
                    {dashboard.wallet ? dashboard.wallet.bankName : "N/A"}
                  </h6>
                  {/* ID: BNK-{user.id && user.id} */}

                  <h6
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                    }}
                  >
                    {dashboard.wallet ? dashboard.wallet.nuban : "N/A"}
                  </h6>
                  {/* user.state */}
                </div>
                <div className="col-6 col-md-3">
                  {/* <h6 style={{
        fontFamily: PrimaryTheme.fonts?.LightFont,
        marginBottom: 0
      }}>TODAY’S EARNINGS</h6>
      <h1 className="earninig-amount" style={{
        fontFamily: PrimaryTheme.fonts?.MediumFont,

        fontSize: PrimaryTheme.fontSizes?.heading,
        marginBottom: 0
      }}>{dashboard.todayCommission ? getCurrency(dashboard.todayCommission) : getCurrency("0")}</h1> */}
                </div>
              </div>
            </div>
          </div>

          {/* cards  */}
          <div className="row mb-5">
            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="first"
                title="TOTAL USERS"
                isLoading={requestLoading}
                onMenuChange={(e: any) =>
                  handleChangeF(e.target.value, "request")
                }
                buttonTitle="."
                hasMenu
                hasButton
                value={
                  // JSON.stringify(requestDashboardReducer.numberOfLoanRequests)
                  //   ? requestDashboardReducer.numberOfLoanRequests.toLocaleString()
                  //   : "0"
                  "0"
                }
                buttonColor={PrimaryTheme.white}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="second"
                title="YOUR RANK"
                isLoading={approveLoading}
                onMenuChange={(e: any) =>
                  handleChangeF(e.target.value, "approve")
                }
                // value={
                //   JSON.stringify(requestDashboardReducer.numberOfApprovedLoans)
                //     ? requestDashboardReducer.numberOfApprovedLoans.toLocaleString()
                //     : "0"
                // }
                value={"0"}
                buttonTitle="."
                hasMenu
                hasButton
                buttonColor={PrimaryTheme.white}
              />
            </div>

            <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <Meter
                hasTransfer={TransferTargetState ? TransferTargetState : 0}
                value={POSWithdrawState ? POSWithdrawState : 0}
                isLoading={targetLoading}
                hasMenu
                title="Target"
                width={300}
                height={157}
                subTitle="Per POS/Agent"
                onMenuChange={(e: any) => handleTarget(e.target.value)}
                hasSpecialFontSize={"45px"}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12  mb-3" style={{ paddingBottom: "100px" }}>
              <Tabs>
                {userType === "8" ? (
                  <TabList>
                    {/* <Tab>Agents</Tab>
                    <Tab>Trade Partners/Aggregators</Tab> */}
                    <Tab>Sales Manager</Tab>
                    <Tab>Regional Manager</Tab>
                  </TabList>
                ) : (
                  <TabList>
                    <Tab>Agents</Tab>
                    <Tab>Trade Partners/Aggregators</Tab>
                  </TabList>
                )}

                <TabPanel>
                  <div style={{ marginBottom: "20px" }}>
                    <Filters
                      hasSearch
                      searchState={searchState}
                      handleSearch={(e: any) => setSearchState(e.target.value)}
                      onClear={handleClear}
                    />
                  </div>
                  {list ? (
                    <React.Fragment>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th scope="col">S/N</th>
                              <th scope="col">
                                {userType !== "8" ? "AGENT ID" : "ID"}
                              </th>
                              <th scope="col">
                                {userType !== "8" ? (
                                  <span>AGENT NAME</span>
                                ) : (
                                  <span>Coordinator Name</span>
                                )}
                              </th>
                              <th scope="col">Amount</th>
                              <th scope="col">TRANSACTIONS(VAL)</th>
                              <th scope="col">
                                STATE/{userType !== "8" ? "LGA" : "REGION"}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {list.length !== 0 &&
                              list?.map((item: any, index: number) => (
                                <tr
                                  title="Click to view"
                                  key={index}
                                  className="pointer text-center"
                                >
                                  <th scope="row">{getIndexSeed(index)}</th>
                                  <td>
                                    {userType !== "8" ? (
                                      <span>
                                        {" "}
                                        BNK-{item.agentId ? item.agentId : "-"}
                                      </span>
                                    ) : (
                                      <span>
                                        {item.coordinatorId
                                          ? item.coordinatorId
                                          : "-"}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {userType !== "8" ? (
                                      <span>
                                        {" "}
                                        {item.agentName ? item.agentName : "-"}
                                      </span>
                                    ) : (
                                      <span>
                                        {" "}
                                        {item.coordinatorName
                                          ? item.coordinatorName
                                          : "-"}
                                      </span>
                                    )}
                                  </td>
                                  <td>{getCurrency(item.amount)}</td>
                                  <td>
                                    {item.transactionCount.toLocaleString()}
                                  </td>
                                  <td>
                                    {item.state ? item.state : "N/A" + "/"}
                                    {userType !== "8"
                                      ? item.lga
                                        ? item.lga
                                        : "N/A"
                                      : item.region
                                      ? item.region
                                      : "N/A"}
                                  </td>

                                  {/* <td
                                   
                                  >
                                    {item.targetStatus === 1 && (
                                      <span className="badge badge-pill badge-danger p-2 pl-3 pr-3">
                                        {item.targetStatusName}
                                      </span>
                                    )}

                                    {item.targetStatus === 2 && (
                                      <span className="badge badge-pill badge-success p-2 pl-3 pr-3">
                                        {item.targetStatusName}
                                      </span>
                                    )}

                                    {item.targetStatus === 3 && (
                                      <span className="badge badge-pill badge-warning p-2 pl-3 pr-3">
                                        {item.targetStatusName}
                                      </span>
                                    )}
                                  </td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {list.length === 0 && (
                        <React.Fragment>
                          <p className="text-center mt-3 text-dark w-100">
                            No result
                          </p>
                        </React.Fragment>
                      )}

                      <div className="col-md-12 p-0">
                        {agentPerformanceList.totalItemCount > pageSize && (
                          <PaginationControlled
                            onPageSizeChange={handlePageSizeChange}
                            onChange={handleChange}
                            page={page}
                            total={
                              agentPerformanceList.totalItemCount &&
                              agentPerformanceList.totalItemCount
                            }
                            pageSize={pageSize}
                          />
                        )}
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </TabPanel>
                {/* Trade Partners*/}
                <TabPanel>
                  <div style={{ marginBottom: "20px" }}>
                    <Filters
                      TraderPartnerSearch
                      searchContent={SearchTradePartner}
                      handleTraderPartnerSearchContent={(e: any) =>
                        setSearchTradePartner(e.target.value)
                      }
                      onClear={handleClear}
                    />
                  </div>
                  {getAggregatorList ? (
                    <React.Fragment>
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead className="thead-primary">
                            <tr className="text-center">
                              <th scope="col">S/N</th>
                              <th scope="col"> ID</th>
                              <th>NAME</th>
                              <th scope="col">AMOUNT</th>
                              <th scope="col">TRANSACTIONS(VAL)</th>
                              <th scope="col">STATE/LGA</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getAggregatorList?.length !== 0 &&
                              getAggregatorList?.map(
                                (item: any, index: number) => (
                                  <tr
                                    title="Click to view"
                                    key={index}
                                    className="pointer text-center"
                                  >
                                    <th scope="row">{getIndexSeed(index)}</th>
                                    <td>
                                      {userType !== "8" ? (
                                        <span>
                                          {" "}
                                          BNK-
                                          {item.aggregatorId
                                            ? item.aggregatorId
                                            : "-"}
                                        </span>
                                      ) : (
                                        <span>
                                          {item.coordinatorId
                                            ? item.coordinatorId
                                            : "-"}
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {userType !== "8" ? (
                                        <span>
                                          {" "}
                                          {item.aggregatorName
                                            ? item.aggregatorName
                                            : "-"}
                                        </span>
                                      ) : (
                                        <span>
                                          {item.coordinatorName
                                            ? item.coordinatorName
                                            : "-"}
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {item.amount
                                        ? getCurrency(item.amount)
                                        : "-"}
                                    </td>
                                    <td>
                                      {item.transactionCount.toLocaleString()}
                                    </td>
                                    <td>
                                      {item.state ? item.state : "N/A"}{" "}
                                      {userType !== "8" ? (
                                        <span>
                                          {item.lga ? item.lga : "N/A"}
                                        </span>
                                      ) : (
                                        <span>
                                          {item.region ? item.region : "N/A"}
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>

                      {getAggregatorList?.length === 0 && (
                        <React.Fragment>
                          <p className="text-center mt-3 text-dark w-100">
                            No result
                          </p>
                        </React.Fragment>
                      )}

                      <div className="col-md-12 p-0">
                        {getAggregatorPerformance.totalItemCount > pageSize && (
                          <PaginationControlled
                            onPageSizeChange={handlePageSizeChange}
                            onChange={handleChange}
                            page={page}
                            total={
                              getAggregatorPerformance.totalItemCount &&
                              getAggregatorPerformance.totalItemCount
                            }
                            pageSize={pageSize}
                          />
                        )}
                      </div>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                      <div className="col-md-12 text-center">
                        <Placeholder
                          variant="text"
                          width={"100%"}
                          height={50}
                          animation="wave"
                          className="display-inline"
                        />
                      </div>
                    </React.Fragment>
                  )}
                </TabPanel>
                <TabPanel>Sales Manager</TabPanel>
                <TabPanel>Regional Manager</TabPanel>
              </Tabs>
            </div>
          </div>
        </div>

        <StatusAlert
          subtitle={subtitle}
          title={title}
          buttonTitle="Goto POS"
          backTitle="Back to dashboard"
          goBack={goBack}
          onClick={handleRefresh}
        ></StatusAlert>
      </div>
    </React.Fragment>
  );
}
